var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showStopAppModal.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }